<div class="trip-detail-popup-right">
    <span *ngIf="countdownTimer" style="color: #f58634; font-weight: 600; font-size: 14px; margin-right: 15px; vertical-align: middle;">
        <i class="fa fa-clock-o"></i> {{ countdownTimer }}
    </span>
    <img src="../../../assets/img/icons8-macos-close-60.png" class="close-icons" (click)="onCancel()" style="vertical-align: middle;" />
</div>
<form class="admin-forms" [formGroup]="bidForm" (ngSubmit)="onSubmit()">
    <div class="accordion-class">
        <h5>{{ data?.participatedPrice && !data?.isEdit ? 'Submitted Bid' : (data?.isEdit ? 'Edit Bid' : 'Submit Bid') }}</h5>
        <mat-divider></mat-divider>

        <div class="row mt-2">
            <div class="col-sm-12 d-flex align-items-center">
                <div class="col-sm-5">
                    <span>Quote ID :</span>
                </div>
                <div class="col-sm-7">
                    <mat-form-field class="no-error-underline" appearance="fill">
                        <input matInput [value]="data.metadata?.quote_id" readonly />
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm-12 d-flex align-items-center">
                <div class="col-sm-5">
                    <span>Bid Price (₹) :</span>
                </div>
                <div class="col-sm-7">
                    <mat-form-field class="no-error-underline" appearance="fill">
                        <input type="number" matInput formControlName="price" placeholder="Enter bid amount" required />
                        <mat-error *ngIf="bidForm.get('price')?.touched && bidForm.get('price')?.invalid">
                            Please enter a valid price.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-sm-12 d-flex align-items-center">
                <div class="col-sm-5">
                    <span>Select Truck :</span>
                </div>
                <div class="col-sm-7">
                    <mat-form-field class="no-error-underline" appearance="fill">
                        <input type="text" placeholder="Select Truck No" matInput [formControl]="truckControl"
                            [matAutocomplete]="auto" required />
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
                            <mat-option *ngFor="let option of filteredOptions | async" [value]="option.truck_number">
                                {{ option.truck_number }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="truckControl.hasError('noTrucks')" style="font-size: 11px; white-space: nowrap;">
                            No trucks found. Please add a truck for this category.
                        </mat-error>
                        <mat-error *ngIf="truckControl.touched && truckControl.invalid && !truckControl.hasError('noTrucks')">
                            Truck selection is required.
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="data?.participatedPrice && !data?.isEdit">
            <div class="col-sm-12 text-center mt-3">
                <small style="color: #6c757d;">
                    <i class="fa fa-info-circle"></i> Click <strong>EDIT BID</strong> below to enable editing
                </small>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 d-flex align-items-center justify-content-center">
                <button *ngIf="data?.participatedPrice && !data?.isEdit" type="button" class="button buttonCancel my-3 me-2"
                    (click)="deleteBid()">
                    DELETE BID
                </button>

                <button *ngIf="data?.participatedPrice && !data?.isEdit" type="button" class="button buttonCancel my-3"
                    (click)="enableEdit()">
                    EDIT BID
                </button>

                <button *ngIf="!data?.participatedPrice || data?.isEdit" type="submit" class="button buttonCancel my-3"
                    [ngClass]="{ 'button-disabled': bidForm.invalid || isLoading }"
                    [disabled]="bidForm.invalid || isLoading">
                    <ng-container *ngIf="!isLoading">
                        {{ data?.isEdit ? 'RESUBMIT BID' : 'SUBMIT BID' }}
                    </ng-container>
                    <ng-container *ngIf="isLoading">
                        <span class="loader"></span>
                    </ng-container>
                </button>
            </div>
        </div>
    </div>
</form>